import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { AvisoService } from 'src/app/core/service/aviso/aviso.service';
import { LoginCyberArkService } from 'src/app/core/service/login-cyberark/login-cyberark.service';

/**
 * Callback do fluxo CyberArk (/cyberark-callback).
 *
 * - Sem `code`+`state`: primeira entrada -> initCodeFlow() (vai ao CyberArk).
 * - Com `code`+`state`: retorno do CyberArk -> tryLoginCodeFlow() e, em
 *   seguida, federa com o gov.br (prompt=none) convergindo no /loginsuccess.
 */
@Component({
  selector: 'app-cyberark-callback',
  template: `<p class="text-center text-lg mt-10">
    Autenticando via Portal Minha Área...
  </p>`,
})
export class CyberArkCallbackComponent implements OnInit {
  constructor(
    private readonly oauthService: OAuthService,
    private readonly router: Router,
    private readonly avisoService: AvisoService,
    private readonly loginCyberArkService: LoginCyberArkService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      this.loginCyberArkService.configurarCyberArk();

      const params = new URLSearchParams(window.location.search);
      const hasCode = params.has('code');
      const hasState = params.has('state');

      await this.oauthService.loadDiscoveryDocument();

      if (hasCode && hasState) {
        await this.oauthService.tryLoginCodeFlow();
        // CyberArk autenticado: reaproveita a sessão federada no gov.br
        // (prompt=none) e converge no callback /loginsuccess já existente.
        this.loginCyberArkService.govBrLoginFederado();
      } else {
        this.oauthService.initCodeFlow();
      }
    } catch (error) {
      console.error('Erro no callback CyberArk:', error);
      this.avisoService.Erro('Falha ao validar a autenticação via Portal Minha Área.');
      this.router.navigate(['/login']);
    }
  }
}
